import type { Copy, ExecutionMetadata, Filters, Props, StateEnvelope } from '@/frontend/pages/Dashboard/Workflows/types'

export function scopedState<T>(envelope: StateEnvelope<T> | undefined, props: Pick<Props, 'organization' | 'connection' | 'selection'>): StateEnvelope<T> | undefined {
  // Deferred responses are visible only in the organization, tenant and query that requested them.
  if (!envelope || String(envelope.organization_id) !== String(props.organization.id) ||
    envelope.tenant !== props.connection.tenant || envelope.selection !== props.selection) return undefined
  return envelope
}
export function displayDate(value: string | null | undefined, fallback: string): string {
  if (!value) return fallback
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? fallback : date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'medium' })
}
export function displayTime(value: string | null, fallback: string): string {
  if (!value) return fallback
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? fallback : date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
}
export function displayDuration(value: number | null | undefined, copy: Copy): string {
  if (value === null || value === undefined) return copy.shared.not_informed
  const seconds = value / 1000
  if (seconds < 60) return `${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(seconds)} ${copy.shared.second}`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} ${copy.shared.minute} ${Math.floor(seconds % 60)} ${copy.shared.second}`
  return `${Math.floor(minutes / 60)} ${copy.shared.hour} ${minutes % 60} ${copy.shared.minute}`
}
export function executionPath(execution: ExecutionMetadata): string {
  return `/dashboard/workflows/executions/${encodeURIComponent(execution.execution_id)}?run_id=${encodeURIComponent(execution.temporal_run_id)}`
}
export function workflowPath(workflow: string): string {
  return `/dashboard/workflows/types/${encodeURIComponent(workflow)}`
}
export function shortExecutionId(value: string): string { return (value.split(':').pop() ?? value).slice(0, 8) }
export function queryData(filters: Filters): Record<string, string | number> {
  const data: Record<string, string | number> = { started_from: filters.started_from, started_to: filters.started_to, limit: filters.limit }
  if (filters.workflow) data.workflow = filters.workflow
  if (filters.status) data.status = filters.status
  return data
}
export function connectionNeedsRepair(props: Props): boolean {
  const errors = [props.tenant_state, props.execution_page, props.summary_state, props.execution_state, props.timeline_state, props.graph_state]
    .map((state) => scopedState(state as StateEnvelope<unknown> | undefined, props)?.error?.code)
  return !props.connection.configured || errors.some((code) => code === 'invalid_credentials' || code === 'tenant_not_found')
}
